import 'magnific-popup'
import $ from 'jquery'
import ExpertVideo from './expert-video'

// options at: https://dimsemenov.com/plugins/magnific-popup/

class Modal {
  constructor() {
    // console.log($(document.location.hash).hasClass('block--type--modal'))
    setTimeout(() => {
      // console.log($(document.location.hash).hasClass('block--type--modal'))
      if (
        document.location.hash !== ''
        && $(document.location.hash).length
        && $(document.location.hash).hasClass('block--type--modal')
      ) {
        // console.log('open', $.magnificPopup.instance.isOpen)

        if ($.magnificPopup.instance.isOpen) {
          document.addEventListener('audiencepopupclose', () => {
            this.openPopupFromHash()
          })
        } else {
          this.openPopupFromHash()
        }

      }

      if ($('#expert-video-modal').length) {
        $.get('/api/v1/expert-videos', (data) => {
          // console.dir(data)
          const expVideo = new ExpertVideo(data)
          expVideo.init()

          $('a.expert-video-trigger').each(function () {
            const href = $(this).attr('href')
            const uuid = $(this).data('uuid')
            // console.log(href)
            $(this).magnificPopup({
              items: {
                src: href,
                type: 'inline'
              },
              //type: 'inline',
              overflowY: 'scroll',
              mainClass: 'expert-video-modal-container',
              fixedContentPos: true,
              callbacks: {
                open: function () {
                  expVideo.setVideo(uuid)
                },
                close: function () {
                  expVideo.stop()
                }
              }
            })
          })
        })
      }

      $('a:not(.expert-video-trigger)').each(function () {
        const href = $(this).attr('href')
        // console.log(href)

        if (
          typeof href !== 'undefined'
          && href.startsWith('#')
          && href !== '#'
          && $(href).hasClass('block--type--modal')
        ) {

          $(this).magnificPopup({
            items: {
              src: href,
              type: 'inline'
            },
            //type: 'inline',
            overflowY: 'scroll',
            callbacks: {
              open: function () {
                if ($(this.content).find('video').length) {
                  $(this.content).find('video')[0].play()
                }

              },
              close: function () {
                // Call pause() here instead of load()
                if ($(this.content).find('video').length) {
                  $(this.content).find('video')[0].pause()
                }
              }
            }
          })
        }

        if (
          typeof href !== 'undefined'
          && href.startsWith('http')
          && $('#popleave').length
        ) {
          $(this).magnificPopup({
            items: {
              src: '#popleave',
              type: 'inline'
            },
            callbacks: {
              open: function() {
                $('#popleave .ok').on('click', function (e) {
                  e.preventDefault
                  e.stopPropagation
                  window.open(href, '_blank')
                  $.magnificPopup.close()
                  return false
                })

                $('#popleave .cancel').on('click', function (e) {
                  e.preventDefault
                  e.stopPropagation
                  $.magnificPopup.close()
                  return false
                })
              }
            }
          })
        }
      })
    }, 250)

  }
  openPopupFromHash() {
    // console.log('opening')
    setTimeout(function () {
      $.magnificPopup.open({
        items: {
          src: document.location.hash,
          type: 'inline'
        },
        overflowY: 'scroll',
        callbacks: {
          open: function () {
            if ($(this.content).find('video').length) {
              $(this.content).find('video')[0].play()
            }

          },
          close: function () {
            // Call pause() here instead of load()
            if ($(this.content).find('video').length) {
              $(this.content).find('video')[0].pause()
            }
          }
        }
      })
    }, 250)
  }
}

export default Modal



// WEBPACK FOOTER //
// ./js/classes/modal.class.js